import { render, staticRenderFns } from "./TempText.vue?vue&type=template&id=4919a3d2&"
import script from "./TempText.vue?vue&type=script&lang=ts&"
export * from "./TempText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports